import React, { FC } from "react";

import classes from "./style/UI_ITOModuleTitle.module.css";

interface IUI_ITOModuleTitle {
  title: string;
}

// заголовок
export const UI_ITOModuleTitle: FC<IUI_ITOModuleTitle> = ({ title }) => {
  return <div className={classes.title}>{title}</div>;
};
